import { render, staticRenderFns } from "./EmailQuotation.vue?vue&type=template&id=9a71bf68"
import script from "./EmailQuotation.vue?vue&type=script&lang=js"
export * from "./EmailQuotation.vue?vue&type=script&lang=js"
import style0 from "./EmailQuotation.vue?vue&type=style&index=0&id=9a71bf68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports